class FloatingEffect {
    constructor() {
        this.circles = [];
        this.init();
    }

    init() {
        this.findCircles();
        this.ensureCirclesVisible();
    }

    findCircles() {
        const heroCircles = document.querySelectorAll('.hero-decorative-icons .hero-circle');
        this.circles = Array.from(heroCircles);
    }

    ensureCirclesVisible() {
        this.circles.forEach((circle) => {
            circle.classList.add('floating-ready');
        });
    }
}

function initializeFloating() {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            new FloatingEffect();
        });
    } else {
        new FloatingEffect();
    }
}

export { FloatingEffect, initializeFloating };

// Auto-initialize if loaded directly
if (typeof window !== 'undefined') {
    window.LastagFloating = FloatingEffect;
    window.initializeFloating = initializeFloating;
}